module.exports = __webpack_public_path__ + "static/media/va.0e3b3cc1.svg";